// eslint-disable-next-line import/prefer-default-export
export const APPLICATION_MAX_CONTAINER_WIDTH = 1200
